import { makeStyles, Spinner, Text, tokens, } from '@fluentui/react-components';
import { Warning20Filled } from '@fluentui/react-icons';
import React from 'react'
import { rootUseStyles } from '../taskpane/fluent-style';


const useStyles = makeStyles({

    paragraph: {
        margin: "6px 0",
    },
    section: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "25px",
        gap: "10px",
    },
    warning: {
        border: `1px solid #BC4B09`,
        borderRadius: "4px",
        backgroundColor: "#BC4B091f",
        width: "100%",
        display: "flex",
        alignItems: "start",
        flexDirection: "column",
        padding: "10px",
    },
    scanTitle: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
    },
    scanDescription: {
        paddingLeft: "25px",
        margin: "6px 0",
    },
    spinner: {
        height: "80px",
        width: "80px",
    }

});



export default function LoadingProgress({

    label = "Scanning the email"
}: {
    label?: string
}) {

    return (
        <section
            className={`${rootUseStyles().root} ${useStyles().section}`}
        >
            <Spinner
                size="huge"
                labelPosition="below" label={label}
            />
            <Text as="p" align='center' className={useStyles().paragraph}>This may take a few minutes...</Text>
            <div className={useStyles().warning}>
                <div className={useStyles().scanTitle}>
                    <Warning20Filled style={{ color: "#BC4B09" }} />
                    <Text
                        as="p"
                        weight='bold'
                        block
                        className={useStyles().paragraph}
                    >
                        Caution During Scan
                    </Text>
                </div>
                <Text as="p" block className={useStyles().scanDescription}>
                    Please <strong>avoid interacting with this email</strong> while it's being scanned. This helps keep everything safe and accurate.
                </Text>
            </div>
        </section>
    );
}
